import { useEffect, useRef } from "react";
import type { TruckGatepassFormData } from "@features/gatepass/schema/truckGatepassFormSchema";
import type { UseFormReturn } from "react-hook-form";
import { syncTruckEntryDateField, toDateOnlyKey } from "./truckEntryDateSync";

export const useTruckEntryDateSync = (
  formData: UseFormReturn<TruckGatepassFormData>,
  updateFormData: (key: string, value: unknown) => void,
) => {
  const expectedEntryDate = formData.watch("expectedEntryDate");
  const jobStartDate = formData.watch("jobStartDate");
  const previousExpectedKey = useRef(toDateOnlyKey(expectedEntryDate));
  const previousJobStartKey = useRef(toDateOnlyKey(jobStartDate));

  useEffect(() => {
    const nextExpectedKey = toDateOnlyKey(expectedEntryDate);
    if (nextExpectedKey && nextExpectedKey !== previousExpectedKey.current) {
      syncTruckEntryDateField(formData, updateFormData, "expectedEntryDate", expectedEntryDate);
    }
    previousExpectedKey.current = nextExpectedKey;
  }, [expectedEntryDate, formData, updateFormData]);

  useEffect(() => {
    const nextJobStartKey = toDateOnlyKey(jobStartDate);
    if (nextJobStartKey && nextJobStartKey !== previousJobStartKey.current) {
      syncTruckEntryDateField(formData, updateFormData, "jobStartDate", jobStartDate);
    }
    previousJobStartKey.current = nextJobStartKey;
  }, [jobStartDate, formData, updateFormData]);
};
